import { ChevronDown } from "react-feather";
import Select, { components } from 'react-select'
import DropDown from '../../DropDown';

const DropdownIndicator = (props) => (
	<components.DropdownIndicator {...props}>
		<ChevronDown
			size={18}
			className="dropdown-chevron"
			style={{
				transition: "transform 0.2s",
				transform: props.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
			}}
		/>
	</components.DropdownIndicator>
);

const FundSelector = ({ updateTickerStatus, tickerOption, setState, state, onUpdateTickerGroup, needsTickerData, fundsCovered, passedFunds }) => {
	const { selectedTickerGroup, tickers, selectionGroups } = state;
	const coveredFundsIdsArray = fundsCovered && fundsCovered.map(f => f.sourceId);

	const selectionGroupsOptions = selectionGroups && selectionGroups.filter(sg => {
		if (coveredFundsIdsArray.length === 0) return true;
		const fundArr = sg.funds.filter(f => coveredFundsIdsArray.includes(f.id));
		return fundArr.length > 0;
	});
	const funds = selectedTickerGroup ? fundsCovered.length > 0 ? selectedTickerGroup.funds.filter(f => coveredFundsIdsArray.includes(f.id)) : selectedTickerGroup.funds : passedFunds ? passedFunds : []
	const selectedFund = funds && tickers && tickers[0] && funds.find(f => f.fundNumber === tickers[0])
	const chooseFund = (fund) => {
		setState({ tickers: [fund.fundNumber] }, () => updateTickerStatus(true));
	};

	const chooseOffer = (offer) => {
		setState({ selectedTickerGroup: offer }, () => needsTickerData && onUpdateTickerGroup(true));
	}

	return (
		<>
			{!passedFunds && <DropDown ellipseWidth={230} stringStyle={{ padding: '11px 0' }} clickable fixed fullWidth label={tickerOption?.selectionName} value={selectedTickerGroup && selectedTickerGroup.offerName} maxDropdownHeight={"max(180px, calc(98vh - 372px))"}>
				{selectionGroupsOptions.sort((a, b) => {
					if (!a.offerName) return -1;
					else if (!b.offerName) return 1;
					else return a.offerName.localeCompare(b.offerName);
				}).map((option, index) => (
					<li key={index} onClick={() => chooseOffer(option)}>
						{option.offerName}
					</li>
				))}
			</DropDown>}
			{(passedFunds || (!passedFunds && selectedTickerGroup)) &&
				<>
					<label className={`label-input${passedFunds ? '' : ' mt-l'}`}>{tickerOption.subSelectionName}</label>
					<Select
						options={funds && funds.length > 0 ? funds.sort((a, b) => {
							if (!a.fundName) return -1;
							else if (!b.fundName) return 1;
							else return a.fundName.localeCompare(b.fundName);
						}).map(f => ({ value: f, label: f.fundName })) : []}
						className="search-select-field fund-selector"
						classNamePrefix="search-select-field"
						placeholder="Search"
						value={selectedFund ? { label: selectedFund.fundName, value: selectedFund } : null}
						components={{ IndicatorSeparator: () => null, DropdownIndicator }}
						blurInputOnSelect={true}
						onChange={(fund) => chooseFund(fund.value)}
						menuPosition="fixed"
						styles={{
							menuList: (provided) => ({
								...provided,
								maxHeight: "max(180px, calc(98vh - 472px))",
								overflowY: "auto",
							}),
							option: (provided, state) => ({
								...provided,
								padding: "0.75rem 0.5rem"
							})
						}}

					/>
				</>
			}
		</>
	)
}

export default FundSelector;
